import React from 'react';
import styled from 'styled-components';
import Image from 'gatsby-theme-core/src/components/image';
import Container from 'gatsby-theme-core/src/components/container';
import Button from 'gatsby-theme-core/src/components/button';
import dateFormat from '../date-format';

const HighlightedPosts = styled.section`
  overflow: auto;
  padding-bottom: 60px;
  display: grid;
  grid-auto-rows: auto;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 26.666666666666667px;
`;

const HighlightedPost = styled.article`
  min-width: 280px;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    min-width: auto;
  }
  &:hover {
    h3 {
      color: ${(props) => props.theme.primaryColor};
    }
  }
  ${Button} {
    display: block;
    text-decoration: none;
  }
  span {
    padding: 15px 0;
    display: block;
    font-size: 0.8889rem;
    text-transform: uppercase;
    color: ${(props) => props.theme.gray3};
  }
  h3 {
    margin: 0;
    font-family: ${(props) => props.theme.standoutFontFamily};
    font-size: 1.222rem;
    color: ${(props) => props.theme.backgroundColor};
  }
`;

const HighlightedPostsTitle = styled.h2`
  margin: 0;
  padding: 60px 0 30px 0;
  font-family: ${(props) => props.theme.standoutFontFamily};
  font-size: 1.556rem;
  text-transform: uppercase;
`;

const HighlightedPostsComponent = ({ highlightedPosts }) => (
  <Container>
    <HighlightedPostsTitle>Lees ook</HighlightedPostsTitle>
    <HighlightedPosts>
      {highlightedPosts.map((highlightedPost) => (
        <HighlightedPost key={highlightedPost.id}>
          <Button wrapper to={highlightedPost.path}>
            {highlightedPost?.featuredImage?.node && (
              <Image
                image={highlightedPost.featuredImage.node}
              />
            )}
            <span>{dateFormat(highlightedPost.date)}</span>
            <h3
              dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                __html: highlightedPost.title,
              }}
            />
          </Button>
        </HighlightedPost>
      ))}
    </HighlightedPosts>
  </Container>
);

export default HighlightedPostsComponent;
